import React, {useEffect, useState} from 'react';
import {Box, makeStyles, Tab, Tabs, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import {useSelector} from "react-redux";
import {TextLink, Loader} from "../../../components";
import axios from "axios";
import {adminToken} from "../../../helper";
import styles from "../../../components/Table/styles.module.scss";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))


const initialFilterState = {
    payment_type: "",
    reference_no: "",
    transaction_id: "",
    comment: ""
};

function SPPaymentPopup({spPayments, handleCloseSPPay, currentpayid, setCPage}) {
    const data = spPayments.filter((item)=>{
            return item?.id == currentpayid
        })
    const {user} = useSelector(state => ({
            user: state.user
        }));
        
    const [filterState, setFilterState] = useState(initialFilterState);

    useEffect(() => {
        
    }, [])

    const [modalStyle] = useState(getModalStyle);
    const [spLoader, setSpLoader] = useState(false);
    
    const classes = useStyles()

    
    const loading = useSelector(state => state.loading);

    return (
        <div style={modalStyle} className={'modal-paper-small'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseSPPay}
                />
            </div>
            <div className={'modal-header'}>
                <h5>SP Payment</h5>
            </div>
            &nbsp;&nbsp;&nbsp;
            Subscription: <span style={{color:'rgb(8 157 175)',fontSize:'16px'}}><b>{data[0].subscription_id}</b></span>
            &nbsp;&nbsp;&nbsp;
            Provider: <span style={{color:'rgb(8 157 175)',fontSize:'16px'}}><b>{data[0].sp_id}</b></span>
            &nbsp;&nbsp;&nbsp;
            Name : <span style={{color:'rgb(8 157 175)',fontSize:'16px'}}><b>{data[0].get_s_p_details?.first_name} {data[0].get_s_p_details?.last_name}</b></span>
            &nbsp;&nbsp;&nbsp;
            Mobile: <span style={{color:'rgb(8 157 175)',fontSize:'16px'}}><b>{data[0].get_s_p_details?.mobile}</b></span>
            <div className={'modal-body'}>
                
                <table width="100%">
                    <tr>
                        <td>Total Payment</td>
                        <td>:</td>
                        <td> {data[0].amount}/-</td>
                    </tr>
                    <tr>
                        <td>Payment Type</td>
                        <td>:</td>
                        <td>
                            <select onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="payment_type" value={filterState?.payment_type}>
                                <option value="">Payment Type</option>
                                <option value="Google Pay">Google Pay</option>
                                <option value="Phone Pay">Phone Pay</option>
                                <option value="Paytm">Paytm</option>
                                <option value="Banck Transfer">Banck Transfer</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>Reference No</td>
                        <td>:</td>
                        <td><input type="text" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="reference_no" value={filterState?.reference_no}/></td>
                    </tr>
                    <tr>
                        <td>Transaction</td>
                        <td>:</td>
                        <td><input type="text" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="transaction_id" value={filterState?.transaction_id}/></td>
                    </tr>
                    <tr>
                        <td>Comment</td>
                        <td>:</td>
                        <td><textarea rows="3" cols="30" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="comment" value={filterState?.comment}></textarea></td>
                    </tr>
                </table>
                <button className='btn btn-primary' onClick={(status) => {
                    setSpLoader(true);
                adminToken().then(token =>
                    axios.post(`${AWS_SERVER_APIS}/makesppayment`, {
                        payment_by: user.first_name+' '+user.last_name,
                        subscription_id: data[0].subscription_id,
                        sp_id: data[0].sp_id,
                        transaction_id: filterState.transaction_id,
                        payment_type: filterState.payment_type,
                        reference_no: filterState.reference_no,
                        total: data[0].amount,
                        comment: filterState.comment,
                        payment_id: data[0].id,
                    }, {headers: {Authorization: `Bearer ${token}`}})
                        .then(res => {
                            if(res.data.type == 'error'){
                                alert('Error: '+res.data.message);
                            }else{
                                alert('Payment Done Successfull!');
                                handleCloseSPPay()
                                setCPage(1);
                                document.querySelector('.search_commision').click();
                            }
                            setSpLoader(false);
                        })
                );
                }}>Make Payment</button> {spLoader ? (
                    <div className={styles.loading__container}>
                      <Loader />
                    </div>
                  ) : null}
            </div>
        </div>
    );
}

export default SPPaymentPopup;
